import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("上架");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("下架");

const _hoisted_6 = {
  class: "op-btns"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 查看 ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 编辑 ");

import { computed, ref } from 'vue';
import { attractProductUpdateStatus, attractProductUpdateTop, getArreactProdList } from '@/request';
import { getVexTableProps, dateTimeFormat } from '@/config';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRouter } from 'vue-router';
export default {
  name: 'AttractInvestProduct',

  setup(__props) {
    const router = useRouter();
    const form = ref({
      prodName: '',
      status: '',
      companyName: '',
      agencyType: '',
      sponsorKeyword: ''
    });
    const table = ref();
    const dataTotal = ref(0);
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'prodName',
        title: '招商商品名称',
        width: '200px',
        showOverflow: true
      }, {
        field: 'varietyId',
        title: '品种ID',
        width: '100px',
        showOverflow: true
      }, {
        field: 'companyName',
        title: '招商企业名称',
        width: '200px',
        showOverflow: true
      }, {
        field: 'sponsorSummary',
        title: '发起人',
        width: '140px',
        showOverflow: true
      }, {
        field: 'contactName',
        title: '联系人',
        width: '100px',
        showOverflow: true
      }, {
        field: 'contactPhone',
        title: '联系电话',
        width: '130px',
        showOverflow: true
      }, {
        field: 'agencyTypeName',
        title: '代理商类型',
        width: '120px',
        showOverflow: true
      }, {
        field: 'publishDate',
        title: '发布日期',
        width: '120px'
      }, {
        field: 'deadline',
        title: '截止日期',
        width: '120px'
      }, {
        field: 'createBy',
        title: '创建人',
        width: '150px',
        showOverflow: true
      }, {
        field: 'updateAt',
        title: '更新时间',
        width: '200px',
        showOverflow: true
      }, {
        field: 'showSource',
        title: '展示渠道',
        width: '150px',

        formatter({
          cellValue
        }) {
          return cellValue === 1 ? '小程序' : '未知';
        },

        showOverflow: true
      }, {
        field: 'applySource',
        title: '申请渠道',
        width: '150px',

        formatter({
          cellValue
        }) {
          return cellValue === 1 ? '小程序' : '未知';
        },

        showOverflow: true
      }, {
        field: 'status',
        title: '状态',
        width: '150px',

        formatter({
          cellValue
        }) {
          return cellValue === 1 ? '上架' : '下架';
        },

        showOverflow: true
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        width: '280px',
        minWidth: '280px',
        showOverflow: false,
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getArreactProdList(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, form.value)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });

    function updateTop(row) {
      const isTop = row.isTop === 1 ? 0 : 1;
      const actionStr = isTop === 1 ? '置顶' : '取消置顶';
      ElMessageBox.confirm(`确定将「${row.prodName}」${actionStr}吗？`, {
        title: actionStr
      }).then(() => {
        attractProductUpdateTop({}, {
          params: {
            zsProdId: row.zsProdId,
            isTop,
            __repeat: true,
            __warn: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success(actionStr + '成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function updateStatus(status) {
      let statusStr = status === 1 ? '上架' : '下架';
      let selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请选择要操作的商品');
        return;
      }

      ElMessageBox.confirm(`是否确认${statusStr}`, {
        title: statusStr
      }).then(() => {
        attractProductUpdateStatus({}, {
          params: {
            status,
            zsProdIdList: selectRows.map(item => item.zsProdId).join(','),
            __repeat: true,
            __warn: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success(statusStr + '成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function reset() {
      form.value = {
        prodName: '',
        companyName: '',
        status: '',
        agencyType: '',
        sponsorKeyword: ''
      };
      table.value.commitProxy('reload');
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "商品名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.prodName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.prodName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "招商企业名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.companyName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.companyName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.status = $event),
                placeholder: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "上架",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "下架",
                  value: "2"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "代理商类型"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.agencyType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.agencyType = $event),
                placeholder: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "全国总代",
                  value: "national"
                }), _createVNode(_component_el_option, {
                  label: "省区代理",
                  value: "provincial"
                }), _createVNode(_component_el_option, {
                  label: "地市代理",
                  value: "city"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "发起人"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.sponsorKeyword,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.sponsorKeyword = $event),
                placeholder: "姓名"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[5] || (_cache[5] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: _cache[6] || (_cache[6] = $event => _unref(router).push({
            name: 'SaveAttractInvestProduct'
          }))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[7] || (_cache[7] = $event => updateStatus(1))
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[8] || (_cache[8] = $event => updateStatus(2))
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        previewImg: _withCtx(({
          row
        }) => [_createVNode(_component_el_image, {
          style: {
            "width": "70px",
            "height": "70px"
          },
          src: row.slideshowUrl,
          "preview-src-list": [row.slideshowUrl],
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])]),
        operation: _withCtx(({
          row
        }) => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "success",
          onClick: $event => _unref(router).push({
            name: 'SaveAttractInvestProduct',
            query: {
              id: row.zsProdId,
              isSee: true
            }
          })
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Edit",
          onClick: $event => _unref(router).push({
            name: 'SaveAttractInvestProduct',
            query: {
              id: row.zsProdId
            }
          })
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: row.isTop === 1 ? 'warning' : 'info',
          onClick: $event => updateTop(row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.isTop === 1 ? '取消置顶' : '置顶'), 1)]),
          _: 2
        }, 1032, ["type", "onClick"])])]),
        _: 1
      }, 16)]);
    };
  }

};